import { Trans } from "@lingui/react/macro";
import { SUPPORT_EMAIL } from "@/app/[lang]/constants";
import { cn } from "@/lib/utils";

type WorkspacePaymentIssueContentProps = {
  className?: string;
};

export function WorkspacePaymentIssueContent({
  className,
}: WorkspacePaymentIssueContentProps) {
  return (
    <div
      className={cn(
        "space-y-1 [&_a]:font-medium [&_a]:underline [&_a]:underline-offset-2",
        className,
      )}
    >
      <p>
        <Trans>We need to confirm the option you purchased.</Trans>
      </p>
      <p>
        <Trans>A representative will contact you shortly.</Trans>
      </p>
      <p>
        <Trans>
          If you have questions, contact{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </Trans>
      </p>
    </div>
  );
}
